// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VIEW AREA AND SIDEBARS LEFT/RIGHT - START */
#graphileon-main .collapse-toggle {
    width: 20px;
    padding-top: 10px;
    background-color: var(--bs-gray-300);
}
#graphileon-main .collapse-toggle:hover {
    background-color: var(--bs-gray-400);
}
#content[role="view-area"] {
	position: relative;
	flex: 1;
	overflow: auto;
}
#sidebar-left[role="view-area"] {
	width: 400px;
	overflow-y: auto;
}
.collapsible.collapsed #sidebar-right[role="view-area"], .collapsible.collapsed #sidebar-left[role="view-area"]{
	display: none;
}
#sidebar-left[role="view-area"] > .graphileon-container,
#sidebar-right[role="view-area"] > .graphileon-container {
	margin-bottom: 0.125rem;
}
#sidebar-right[role="view-area"] {
	width: 360px;
	flex-direction: column;
	overflow-y: auto;
}
#sidebar-right[role="view-area"] .graphileon-container {
	flex: 1;
}
#sidebar-right[role="view-area"] .graphileon-container.collapsed{
	flex: none;
}
#sidebar-right[role="view-area"] .graphileon-viewrenderer {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}
#sidebar-right:empty {
	display: none;
}
#sidebar-right {
	display: inherit;
}
/* VIEW AREA AND SIDEBARS LEFT/RIGHT - END */

/* CONTAINER - START */
.graphileon-container .container-content {
	position: relative;
	overflow: auto;
	/* If container in another container */
	max-width: 100%;
}
.graphileon-container.default {
	position: relative;
	display: flex;
	flex-direction: column;
}
.container-fixed-height .graphileon-viewrenderer {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}
.container-content-height .graphileon-viewrenderer {
	/* Prevent content from trying to fill container, as defined in .container-fixed-height */
	position: relative;
}
.graphileon-viewrenderer-output {
	flex: 1;
	overflow: auto;
	position: relative;
	/*display: contents;*/
}
/* CONTAINER - END */

/* COMMON DECLARATIONS - START */
.context-menu .context-menu-item:hover {
	background-color: var(--bs-secondary-bg-subtle);
}
.error {
	font-family: var(--graphileon-font-family);
	color: var(--bs-danger);
}
/* COMMON DECLARATIONS - END */

/* COPY TO CLIPBOARD - START */
.copy-to-clipboard {
    cursor: pointer;
    position: relative;
}

.copy-to-clipboard:hover:after {
    content: "\\f0c5"; /* fa-copy */
    font-family: FontAwesome;
    color: var(--bs-dark);
    font-weight: 900;
    font-style: normal;
    position: absolute;
    top: 0;
    right: 0;
}

.copy-to-clipboard.copied:after {
    content: "\\f00c" !important; /* fa-check */
    color: var(--bs-success) !important;
    font-family: FontAwesome;
    font-weight: 900;
    font-style: normal;
    position: absolute;
    top: 0;
    right: 0;
}
/* COPY TO CLIPBOARD - END */

/* MODAL ALERT (Dialog / alert / confirm / prompt) - START */
.modal.graphileon-modal-alert {
    z-index: 100000;
}
.modal-backdrop.graphileon-modal-alert-backdrop {
    z-index: 99999;
}
#GraphileonAlerts-header {
    padding: .65rem 1rem;
    background-color: transparent;
}
#GraphileonAlerts-header .modal-title {
    font-size: 1rem;
    font-weight: 500;
    color: var(--bs-body-color);
}
#GraphileonAlerts-body {
    padding: 1.1rem 1rem;
}
#GraphileonAlerts-body .message {
    font-size: 1rem;
    color: var(--bs-body-color);
}
#GraphileonAlerts-body .message p:last-child {
    margin-bottom: 0;
}
#GraphileonAlerts-form {
    margin-top: .75rem;
}
#Graphileonprompt::placeholder {
    color: #cfcfcf;
    opacity: 1;
}
#GraphileonAlerts-input-error {
    display: block;
}

#GraphileonAlerts-header.modal-alert-default  { border-bottom: 1px solid var(--bs-border-color); }
#GraphileonAlerts-header.modal-alert-primary  { border-bottom: 2px solid var(--bs-primary); }
#GraphileonAlerts-header.modal-alert-success  { border-bottom: 2px solid var(--bs-success); }
#GraphileonAlerts-header.modal-alert-info     { border-bottom: 2px solid var(--bs-info); }
#GraphileonAlerts-header.modal-alert-warning  { border-bottom: 2px solid var(--bs-warning); }
#GraphileonAlerts-header.modal-alert-danger   { border-bottom: 2px solid var(--bs-danger); }

#GraphileonAlerts-footer .btn:focus,
#GraphileonAlerts-footer .btn:focus-visible,
#GraphileonAlerts-footer .btn.is-default {
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, .35);
    outline: 0;
    position: relative;
    z-index: 1;
}
#GraphileonAlerts-footer .btn-danger:focus,
#GraphileonAlerts-footer .btn-danger:focus-visible,
#GraphileonAlerts-footer .btn-danger.is-default {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, .4);
}
#GraphileonAlerts-footer .btn-success:focus,
#GraphileonAlerts-footer .btn-success:focus-visible,
#GraphileonAlerts-footer .btn-success.is-default {
    box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, .4);
}
#GraphileonAlerts-footer .btn-warning:focus,
#GraphileonAlerts-footer .btn-warning:focus-visible,
#GraphileonAlerts-footer .btn-warning.is-default {
    box-shadow: 0 0 0 0.25rem rgba(255, 193, 7, .45);
}
#GraphileonAlerts-footer .btn-secondary:focus,
#GraphileonAlerts-footer .btn-secondary:focus-visible,
#GraphileonAlerts-footer .btn-secondary.is-default {
    box-shadow: 0 0 0 0.25rem rgba(108, 117, 125, .4);
}
/* MODAL ALERT (Dialog / alert / confirm / prompt) - END */

/* CONTAINER MENU BUTTON (\$container.menu) - START */
/* The header is a flex row: title area (w-100) + buttons. By default the title area has
   min-width:auto, so it refuses to shrink below its longest word and pushes the buttons out
   of a narrow header instead. min-width:0 removes that floor; the title then truncates with
   an ellipsis rather than wrapping into a taller header.
   Deliberately scoped to headers that actually carry an action button, so every other
   container keeps its current long-title behaviour. */
.container-header.has-container-menu .container-title-area {
    min-width: 0;
}
/* .title is a <label> (inline); text-overflow needs a block box to apply. */
.container-header.has-container-menu .container-title-area .title {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/* CONTAINER MENU BUTTON (\$container.menu) - END */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
